import { render, staticRenderFns } from "./v-free-apply.vue?vue&type=template&id=1bbec5f8&scoped=true&"
import script from "./v-free-apply.vue?vue&type=script&lang=ts&"
export * from "./v-free-apply.vue?vue&type=script&lang=ts&"
import style0 from "./v-free-apply.vue?vue&type=style&index=0&id=1bbec5f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbec5f8",
  null
  
)

export default component.exports